var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.root},[_c('VCard',{attrs:{"elevation":"0"}},[(_vm.label)?_c('VCardTitle',[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('VCardText',[_vm._t("default",null,null,{ values: _vm.values })],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }